import { useEffect, useState } from "react";
import { ImageOff, Loader2, MailCheck, MailX } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useApi, fmtDate } from "@/lib/api";

const AuthImage = ({ url, className, testId, onOpen }) => {
  const api = useApi();
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let blobUrl;
    let alive = true;
    api("get", url, undefined, { responseType: "blob" })
      .then((b) => {
        blobUrl = URL.createObjectURL(b);
        if (alive) setSrc(blobUrl);
      })
      .catch(() => alive && setFailed(true));
    return () => {
      alive = false;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [api, url]);
  if (failed) return <div className={`grid place-items-center bg-[#F7F4EF] ${className}`}><ImageOff className="h-5 w-5 text-[#5C7067]" /></div>;
  if (!src) return <div className={`grid place-items-center bg-[#F7F4EF] ${className}`}><Loader2 className="h-5 w-5 animate-spin text-[#5C7067]" /></div>;
  return <img src={src} alt="صورة البلاغ" data-testid={testId} onClick={() => onOpen?.(src)} className={`cursor-zoom-in object-cover ${className}`} />;
};

export const MaintenancePhotos = ({ task }) => {
  const [big, setBig] = useState(null);
  if (!task.photo_ids?.length) return null;
  return (
    <>
      <div className="mt-3 flex gap-2" data-testid={`photos-${task.code}`}>
        {task.photo_ids.map((fid, i) => (
          <AuthImage key={fid} url={`/maintenance/${task.id}/photos/${fid}`} onOpen={setBig}
            className="h-20 w-20 rounded-lg border border-[#E5DEC9]" testId={`photo-${task.code}-${i}`} />
        ))}
      </div>
      <Dialog open={!!big} onOpenChange={(o) => !o && setBig(null)}>
        <DialogContent className="max-w-3xl p-2" data-testid="photo-preview-dialog">
          <DialogTitle className="sr-only">صورة البلاغ</DialogTitle>
          {big && <img src={big} alt="صورة البلاغ" className="max-h-[80vh] w-full rounded-md object-contain" />}
        </DialogContent>
      </Dialog>
    </>
  );
};

export const EmailStatus = ({ log, testId }) => {
  if (!log) return null;
  const ok = log.result === "sent";
  const Icon = ok ? MailCheck : MailX;
  const text = ok ? "أُرسل إشعار للمالك" : log.result === "skipped" ? "لا يوجد بريد للمالك" : "تعذر إرسال الإشعار";
  return (
    <p data-testid={testId} className={`mt-2 flex items-center gap-1 text-xs ${ok ? "text-emerald-700" : "text-red-600"}`}>
      <Icon className="h-3.5 w-3.5" />{text} · {fmtDate(log.at)}
    </p>
  );
};
